import { call, put, select } from 'redux-saga/effects';
import nsApi from '@netsapiens/netsapiens-js/dist/api';
import _ from 'lodash';
import i18n from 'i18next';
import { selectIncomingSmsQueues, setIncomingSmsQueues } from '../../../state/ua/uaSlice';
import generateSmsObject from '../../../utils/chat/generateSmsObject';
import { selectSessions, setSessionsList } from '../../../state/chat/chatSlice';
import addCard from '../../cardManagment/addCard/addCard';
import { setSnackbar } from '../../../state/snackbar/snackbarSlice';

export default function* acceptSms({ payload: { session: smsSession } }) {
  const debug = localStorage.getItem('debugFlag') === 'true' || true;
  if (debug) console.debug('this is in acceptsms session: ', smsSession);

  const args = {
    object: 'messagesession',
    action: 'accept',
    session_id: smsSession.session_id,
    queue_session_id: smsSession.queue_session_id,
    term_queue: smsSession.term_queue,
    user: smsSession.user,
    domain: smsSession.domain,
  };

  const messageSessionPost = yield call(nsApi.v2, {
    object: 'messagesession',
    action: 'post',
    data: args,
  }, `domains/${smsSession.domain}/users/${smsSession.user}/messagesessions/${smsSession.session_id}/accept`);

  if (debug) console.debug('this is messagesessiontopost: ', messageSessionPost);
  if (messageSessionPost?.code !== 202) {
    console.debug('Failed to accept sms session');
    console.error('Failed to accept sms session');

    // remove the session from the list of incoming sms queue sessions
    const currentIncomingSmsQueues = yield select(selectIncomingSmsQueues);
    const updatedCurrentIncomingSmsQueues = currentIncomingSmsQueues.filter((session) => session.session_id !== smsSession.session_id);

    yield put(setIncomingSmsQueues(updatedCurrentIncomingSmsQueues));

    yield put(setSnackbar({
      open: true,
      message: i18n.t('CONVERSATION_ALREADY_TAKEN'),
      type: 'INFO',
    }));

    return;
  }

  // remove the session from the list of incoming sms queue sessions
  const currentIncomingSmsQueues = yield select(selectIncomingSmsQueues);
  const updatedCurrentIncomingSmsQueues = currentIncomingSmsQueues.filter((session) => session.session_id !== smsSession.session_id);

  yield put(setIncomingSmsQueues(updatedCurrentIncomingSmsQueues));

  // add card immediately here
  const contactToChip = (contact) => {
    const contactId = contact.contact_id ?? contact.id ?? undefined;
    return {
      contact,
      key: (contactId !== undefined) ? contactId : Date.now(),
      id: (contactId !== undefined) ? contactId : Date.now(),
      contact_id: (contactId !== undefined) ? contactId : Date.now(),
      label: contact.name,
      name: contact.name,
      initials: (contact.initials !== undefined) ? contact.initials : '',
      gravatar: (contact.gravatar !== undefined) ? contact.gravatar : '',
    };
  };

  const contact = {
    label: smsSession.remote,
    name: smsSession.remote,
    customContact: true,
  };
  const chipDataConfirm = contactToChip(contact);

  // if session does not exist, create new session
  const smsObj = generateSmsObject({
    sessionId: smsSession.session_id,
    chipData: [chipDataConfirm],
    smsani: smsSession.smsani,
  });
  smsObj.queue_session_id = smsSession.queue_session_id;
  smsObj.queue_status = smsSession.queue_status;
  smsObj.term_queue = smsSession.term_queue;

  const sessionsCurr = yield select(selectSessions);

  // Using Lodash to filter out sessions with the same id as smsObj.id
  const updatedSessions = [
    smsObj,
    ..._.filter(sessionsCurr, (session) => session.id !== smsObj.id),
  ];
  if (debug) console.debug('this is updatedSessions: ', updatedSessions);

  yield put(setSessionsList(updatedSessions));

  const sendMessageParams = {
    chat: smsObj,
  };
  if (debug) console.debug('this is sendMessageParams: ', sendMessageParams);

  yield call(addCard, {
    payload:
    {
      type: 'new-chat',
      sessionId: smsSession.session_id,
      sendMessageParams,
    },
  });
}
